import React from "react";

export const LogoVkIcon = ({ fillF, fillS }) => {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3 13.56C3 8.58197 3 6.09295 4.54648 4.54648C6.09295 3 8.58197 3 13.56 3H14.44C19.418 3 21.907 3 23.4535 4.54648C25 6.09295 25 8.58197 25 13.56V14.44C25 19.418 25 21.907 23.4535 23.4535C21.907 25 19.418 25 14.44 25H13.56C8.58197 25 6.09295 25 4.54648 23.4535C3 21.907 3 19.418 3 14.44V13.56Z"
        fill={fillF ? fillF : "white"}
      />
      <path
        d="M14.7064 18.9002C9.684 18.9002 6.81931 15.4467 6.69995 9.7002H9.21574C9.29838 13.918 11.1531 15.7046 12.6221 16.073V9.7002H14.9911V13.3378C16.4418 13.1813 17.9658 11.5236 18.48 9.7002H20.849C20.4541 11.9472 18.8014 13.6049 17.6262 14.2864C18.8014 14.8389 20.6838 16.2848 21.4 18.9002H18.7923C18.2322 17.1504 16.8366 15.7967 14.9911 15.6125V18.9002H14.7064Z"
        fill={fillS ? fillS : "#0077FF"}
      />
    </svg>
  );
};
